import {cx} from '../util';
import brandMark from '../brand/mark.json';
export interface LogoProps {size?:number;variant?:'full'|'mark'|'wordmark';tile?:boolean;className?:string;title?:string}
export function Logo({size=32,variant='full',className,title='Grow My X'}:LogoProps){
 const mark=variant==='mark';
 return <svg width={mark?size:size*4.7} height={mark?size:size*1.3} viewBox={mark?'0 0 40 40':'0 0 210 58'} className={cx('gmx-logo',className)} role={title?'img':undefined} aria-label={title||undefined} aria-hidden={title?undefined:true} style={{maxWidth:'100%',flexShrink:0,color:'var(--gf-text)'}}>
 {variant!=='wordmark'&&<svg width="40" height="40" viewBox={brandMark.viewBox}><path d={brandMark.path} fill="currentColor"/></svg>}
 {!mark&&<text x={variant==='wordmark'?0:48} y="31" fill="currentColor" fontFamily="Arial, sans-serif" fontSize="25" fontWeight="750" letterSpacing="-1">Grow My X</text>}
 </svg>;
}
export function LogoMark(props:Omit<LogoProps,'variant'>){return <Logo {...props} variant="mark"/>;}
